var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFMicLlmCancelNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70312 0.0253906H10.5957C11.0632 0.0253906 11.4602 0.188769 11.7881 0.516602C12.116 0.844476 12.2802 1.2415 12.2803 1.70898V10.6016C12.2803 11.0675 12.116 11.4633 11.7881 11.79C11.4602 12.1167 11.0633 12.2803 10.5957 12.2803H1.70312C1.23725 12.2802 0.84139 12.1168 0.514648 11.79C0.187982 11.4633 0.0253906 11.0674 0.0253906 10.6016V1.70898C0.0254524 1.24154 0.188018 0.844444 0.514648 0.516602C0.841396 0.188704 1.23728 0.0254199 1.70312 0.0253906ZM1.67871 10.627H10.6211V1.68457H1.67871V10.627Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFMicLlmCancelNew);
export default __webpack_public_path__ + "static/media/f-mic-llm-cancel-new.6ec30fb4addae1bb58fada99cdd2abd9.svg";
export { ForwardRef as ReactComponent };